/**
 * Cart content component exports
 *
 * @since 1.0.0
 */

export { CartPopupContent } from './component';
export type { CartPopupContentProps } from './types';
